import React from "react";
import { Navigate, Outlet, useLocation, useMatch } from "react-router";
import { SocketProvider } from "../context/SocketContext";
import { useAuth } from "../context/AuthContext";
import ThemeToggle from "./ThemeToggle";
import AccountMenu from "./AccountMenu";
import AppNavigation from "./AppNavigation";

const SocketLayout = () => {
  const match = useMatch("/courses/:slug/*");
  const slug = match?.params.slug;
  const { userId, authLoading, sessionVerified } = useAuth();
  const { pathname } = useLocation();
  const privatePage = /^\/(courses|choose-plan|subscription-verification|subscription-successful|owner-payouts|group-memberships|payouts)(\/|$)/.test(pathname);
  const authPage = pathname === "/login" || pathname === "/signup";
  const guestOnlyPage = authPage || pathname === "/";
  const standalone = authPage || /^\/(join|choose-plan|subscription-verification|subscription-successful)(\/|$)/.test(pathname);
  if (guestOnlyPage && authLoading) return <div className="min-h-screen bg-white" aria-label="Checking session" />;
  if (guestOnlyPage && sessionVerified && userId) return <Navigate to="/explore" replace />;
  if (privatePage && !userId && !authLoading) return <Navigate to="/login" replace />;
  return (
    <SocketProvider slug={slug}>
      {authPage ? <AppNavigation /> : standalone && <div className="flex justify-end border-b border-gray-200 bg-white px-4 py-2">{userId ? <AccountMenu /> : <ThemeToggle />}</div>}
      <Outlet />
    </SocketProvider>
  );
};

export default SocketLayout;
